import { useSlowLoad } from "@/lib/useSlowLoad";

/**
 * FEAT-044 — loading indicator that escalates its copy when a cold backend is
 * slow to respond. Shows `label` immediately; after ~5s of continuous loading,
 * switches to a "system is waking up" message so a cold start reads as a wait,
 * not a malfunction. Render this only while a query is actually loading.
 */
export function LoadingState({
  label = "Loading…",
  delayMs = 5000,
}: {
  label?: string;
  delayMs?: number;
}) {
  const slow = useSlowLoad(true, delayMs);
  return (
    <div className="state-loading">
      {slow
        ? "The system was idle and is waking up — this can take up to a minute…"
        : label}
    </div>
  );
}
